import { getFilterIndicator } from "../helpers";

import { formatPhoneNumber } from "@/lib/format-data";

import type { FilterStrategy } from "./types";

export const phoneNumberStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (ctx.looksLikePhone) {
      const phoneScore = ctx.hasPhoneFormatting
        ? ctx.phoneDigits.length >= 7
          ? 95
          : 75
        : 70;
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: ctx.phoneDigits,
        optionLabel:
          ctx.phoneDigits.length === 10
            ? formatPhoneNumber(ctx.phoneDigits) || ctx.phoneDigits
            : ctx.phoneDigits,
        type: filterType.type,
        score: phoneScore,
        indicator: getFilterIndicator(filterType),
      });
      return;
    }
    const labelLower = filterType.label.toLowerCase();
    const queryWords = ctx.query.split(/\s+/).filter((w) => w.length > 0);
    const matchesFilterName =
      labelLower.includes(ctx.query) ||
      queryWords.some((word) => labelLower.includes(word));
    const isPurelyNumeric = /^\d+\.?\d*$/.test(ctx.trimmedQuery);
    if (!matchesFilterName && !isPurelyNumeric && !ctx.matchesAnyIdPrefix) {
      const textScore = ctx.looksLikeDate ? 5 : ctx.looksLikeNumber ? 15 : 20;
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: ctx.trimmedQuery,
        optionLabel: `~ "${ctx.trimmedQuery}"`,
        type: filterType.type,
        score: textScore,
        indicator: getFilterIndicator(filterType, false, true),
      });
    }
  },
  isSelected(currentValue, optionValue) {
    return currentValue === optionValue;
  },
  toggle(result) {
    return { value: result.optionValue, clearSearchQuery: true };
  },
};
